import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { ContentHeader, ContentBody } from 'areas/shared/components';
import { Grid } from 'fw/forms';
import API from 'fw/system/API';
import * as APIModules from 'modules/app/API';
import * as Formatter from 'fw/components/formatter/Formatter';
import { EmailStatusLabel } from 'areas/shared/controls';
import * as Notifications from 'fw/globals/Notifications';
import { Button } from 'fw/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExport } from '@fortawesome/free-solid-svg-icons';
import EmailInfoModal from './EmailInfoModal';

class NotificationsTab extends React.Component {
	constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialState = () => {
        return {
			loading: true,
            rows: [],
			title: ""
        };
    }

	componentDidMount() {
		if (!this.props.active)
			return;

		if(this.props.selectedId !== undefined)
        	this.get();
    }

	get = () => {
        var rq = {
            sponsorId: this.props.selectedId
        };

        new API().post(APIModules.Sponsor.url('/sponsorSetup/getSponsorNotifications'), rq,
            {
                success: (r) => {
                    let rows = r.data.items;

                    // Store search results
                    this.setState({ 
						rows: rows, 
						title: r.data.title,
						loading: false 
					});
                },
				error: r => {
                    Notifications.error(r.error.errorMessage);
					this.setState({ loading: false });
                }
            }); 
    }

	openEmailDetailsModal = (emailKey) => {
		this._emailDetailsModal.open({
			modalTitle: 'Email Details',
			emailKey: emailKey
		});
	}

	onExportData = () => {
		var rq = {
            sponsorId: this.props.selectedId
        };

		new API().post(APIModules.Sponsor.url('/sponsorSetup/exportSponsorNotifications'), rq,
			{
				success: (sr) => {
					new API().download(sr.data);
				},
				error: r => {
                    Notifications.error(r.error.errorMessage);
				}
			});
	}

	emailStatusLabelFormatter = ({ value }) => {
        return <EmailStatusLabel emailStatusCode={value} />;
    };

	emailLinkFormatter = (row) => {
		return <Button id="btnOpenEmail" bsStyle="link" onClick={() => this.openEmailDetailsModal(row.dependentValues.emailKey)}>{row.dependentValues.subject}</Button>
    };

    render() {
		if (this.state.loading)
			return null;

		const columns = [
			{ key: 'date', name: 'Date', width: 200, formatter: Formatter.ClientDateTime },
			{ key: 'recipients', name: 'Recipients', width: 200 },
			{ key: 'subject', name: 'Subject', formatter: (row) =>  this.emailLinkFormatter(row), getRowMetaData: (row) => row },
			{ key: 'status', name: 'Status', width: 150, cellClass: "text-center", formatter: this.emailStatusLabelFormatter }
		];
        
        return (
            <React.Fragment>
                <ContentHeader title={"Notifications - " + this.state.title} >
                </ContentHeader>
                <ContentBody> 
                    <Row>
                        <Col md={12}>
                            <Grid
                                columns={columns}
                                items={this.state.rows}
                                height={350}
                                className="table-condensed"
                                rowKey="userId"
                                name="default" />
                        </Col>
                    </Row>
					<Row>
                        <Col md={12}>
							<br/>
							{this.state.rows.length > 0 &&
								<Button
									id="btnExportCsv"
									onClick={this.onExportData}
									className="btn btn-default" >
									<FontAwesomeIcon icon={faFileExport} /> Export CSV
								</Button>
							}
							<EmailInfoModal
								{...this.props}
								visible={true}
								ref={(c) => {
									this._emailDetailsModal = c;
								}} />
						</Col>
					</Row>
				</ContentBody>
            </React.Fragment>
        );
    }
}

export default NotificationsTab;



// WEBPACK FOOTER //
// ./src/areas/admin/sponsorSetup/notifications/NotificationsTab.js